export const LoadingIndicator = () => (
  <div>
    loading...
  </div>
)
